<template>
  <section
    class="relative bg-primary-admin p-32 flex flex-col gap-16"
  >
    <div class="absolute top-0 left-0 w-full">
      <img
        :src="useAssets('/static/images/orn_card_principal.png')"
        alt="ornamento"
        class="size-full"
      />
    </div>

    <div class="flex items-center justify-between">
      <div class="flex items-center gap-12">
        <IconFolder class="size-24 text-primary-admin-10" />
        <h1 class="text-headline-1 text-primary-admin-10">
          {{ t('selectAssessment') }}
        </h1>
      </div>

      <div class="flex items-center gap-8">
        <div
          class="swiper-button-prev-select-assessment size-40 grid place-items-center cursor-pointer bg-white/20 border border-white/10 rounded-full backdrop-blur-[20px]"
        >
          <q-icon name="chevron_left" class="text-primary-admin-10" />
        </div>

        <div
          class="swiper-button-next-select-assessment size-40 grid place-items-center cursor-pointer bg-white/20 border border-white/10 rounded-full backdrop-blur-[20px]"
        >
          <q-icon
            class="transform rotate-180 text-primary-admin-10"
            name="chevron_left"
          />
        </div>
      </div>
    </div>

    <div
      v-if="assessments.loading?.req"
      class="grid grid-cols-6 sm:grid-cols-3 p-24 w-full gap-16"
    >
      <SkeletonCardAssessment v-for="n in 6" :key="n" />
    </div>

    <swiper
      v-else-if="assessments.data?.length > 0"
      :slides-per-view="6"
      :space-between="12"
      :modules="modules"
      :pagination="{
        el: '.swiper-pagination-select-assessment',
        clickable: true,
      }"
      :navigation="{
        nextEl: '.swiper-button-next-select-assessment',
        prevEl: '.swiper-button-prev-select-assessment',
      }"
      class="w-full"
      @reach-end="swiperReachEnd"
    >
      <swiper-slide
        v-for="assessment in assessments.data"
        :key="assessment.id"
        class="!h-auto"
      >
        <CardAssessment :assessment />
      </swiper-slide>

      <swiper-slide
        v-if="assessments.loading?.more"
        class="max-w-[20rem] md:max-w-full !h-auto"
      >
        <div
          class="p-2 rounded-xl !shadow-sm bg-white/80 cursor-default group grid place-items-center h-full max-w-[20rem] md:max-w-full"
        >
          <BaseLoader />
        </div>
      </swiper-slide>
    </swiper>

    <div
      v-else
      class="p-24 md:p-16 w-full flex items-center justify-center"
    >
      <EmptyItem :text="t('noAssessment')" />
    </div>

    <div class="flex justify-center">
      <div class="swiper-pagination-select-assessment !w-max" />
    </div>
  </section>
</template>

<script setup>
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import { Navigation, Pagination } from 'swiper/modules'
import { onMounted, ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { useAssets } from 'js/utils/GLOBAL'
import { useI18n } from 'vue-i18n'

import BaseLoader from 'components/Loader/BaseLoader.vue'
import CardAssessment from 'components/Admin/Card/CardAssessment.vue'
import EmptyItem from 'components/Empty/EmptyItem.vue'
import IconFolder from 'public/icons/folder.svg'
import SkeletonCardAssessment from 'components/Admin/Skeleton/SkeletonCardAssessment.vue'
import useAssessment from 'composables/useAssessment'

const { t } = useI18n()
const { fetchAllAssessments, loadMoreAssessments, assessments } =
  useAssessment()

const modules = ref([Navigation, Pagination])

async function swiperReachEnd(swiper) {
  if (!swiper.isBeginning && swiper.isEnd && assessments.value.next)
    await loadMoreAssessments()
}

onMounted(() => {
  fetchAllAssessments()
})
</script>

<style lang="scss" scoped>
.swiper-pagination-select-assessment {
  --swiper-pagination-bullet-inactive-color: rgba(
    var(--white),
    0.4
  ) !important;
  :deep(.swiper-pagination-bullet-active) {
    background: rgba(var(--white), 1) !important;
  }
}
</style>
